import { render, staticRenderFns } from "./newprice2.vue?vue&type=template&id=4d39266b&scoped=true"
import script from "./newprice2.vue?vue&type=script&lang=js"
export * from "./newprice2.vue?vue&type=script&lang=js"
import style0 from "./newprice2.vue?vue&type=style&index=0&id=4d39266b&prod&scoped=true&lang=css"
import style1 from "./newprice2.vue?vue&type=style&index=1&id=4d39266b&prod&lang=css"
import style2 from "./newprice2.vue?vue&type=style&index=2&id=4d39266b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d39266b",
  null
  
)

export default component.exports